import BaseModel from 'src/model/base.model';
import PartModel from './productdetails.model';
import WarehouseDefaultModel from './warehouseDefault.model';

class ListItem extends BaseModel {
  public listItemNumber: number;
  public manufacturerCode: string;
  public name: string;
  public category: string;
  public quantity: number;
  public shipmentMarking: string;
  public warrantyProvider: string;
  public dispatch: string;
  public replacementMfc: string;
  public replacementPart: string;
  public alternateProductManufacturer: string;
  public alternateProductNumber: string;
  public oemProductNumber: string;
  public oemProductManufacturer: string;
  public inStock: boolean;
  public total: number;
  public price: number;
  public retailPrice: number;
  public image: string;
  public description: string;
  public itemDetailsState: 'pending' | 'loading' | 'loaded' | 'none';
  public warehouseDefault: WarehouseDefaultModel;
}

export default ListItem;
